import { _ as __assign } from './chunks/bundle-CxLxJCBu.js';
import React__default from 'react';
import { GroupChannelListProvider } from './GroupChannelList/context.js';
import { GroupChannelListUI } from './GroupChannelList/components/GroupChannelListUI.js';
import '@sendbird/chat/groupChannel';
import '@sendbird/uikit-tools';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-DXFVroy5.js';
import './chunks/bundle-DRpjMk0B.js';
import './chunks/bundle-BA9oFJ90.js';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-DiK8ifY3.js';
import './chunks/bundle-C-nZYnmy.js';
import './chunks/bundle-DP3z2QNm.js';
import './chunks/bundle-kFa80LJe.js';
import 'react-dom';
import './chunks/bundle-d1cOX5nv.js';
import './chunks/bundle-DS1EhNtb.js';
import './chunks/bundle-Ci-RNuvu.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-CjJk57u5.js';
import './ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-DdJ9pMWn.js';
import './chunks/bundle-BzR1dD25.js';
import './ui/SortByRow.js';
import './chunks/bundle-DGcs2Mkk.js';
import './chunks/bundle-QYB3Mk61.js';
import './GroupChannelList/components/GroupChannelListHeader.js';
import './chunks/bundle-DOfhjbKd.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-C_zEpfCP.js';
import './ui/Header.js';
import './ui/TextButton.js';
import './chunks/bundle-B5157rdG.js';
import './EditUserProfile.js';
import './EditUserProfile/context.js';
import './EditUserProfile/components/EditUserProfileUI.js';
import './chunks/bundle-D9MeorzH.js';
import './ui/Input.js';
import './ui/PlaceHolder.js';
import './ui/Loader.js';
import './chunks/bundle-CzHaD4PM.js';
import './chunks/bundle-AJS7Mngy.js';
import '@sendbird/chat/message';
import './chunks/bundle-BjAeG049.js';
import './GroupChannelList/components/GroupChannelPreviewAction.js';
import './GroupChannelList/components/GroupChannelListItem.js';
import './chunks/bundle-w2yLrIlh.js';
import './chunks/bundle-CewnJAub.js';
import './chunks/bundle-jrZGOZ7u.js';
import './chunks/bundle-Dq0ggazV.js';
import './chunks/bundle-BdE39Lk2.js';
import './chunks/bundle-QsOiwa9F.js';
import './GroupChannel/components/TypingIndicator.js';
import './ui/Badge.js';
import './ui/ChannelAvatar.js';
import './chunks/bundle-BlguTwHI.js';
import './ui/MentionUserLabel.js';
import './chunks/bundle-B5pWUwTI.js';
import './chunks/bundle-AmtSwuex.js';
import './GroupChannelList/components/AddGroupChannel.js';
import './chunks/bundle-CBHlCwa8.js';
import './CreateChannel.js';
import './CreateChannel/components/CreateChannelUI.js';
import './chunks/bundle-CYoJWHCE.js';
import './sendbirdSelectors.js';
import './chunks/bundle-mqagBpi9.js';
import './CreateChannel/components/InviteUsers.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './CreateChannel/components/SelectChannelType.js';

var GroupChannelList = function (props) {
    return (React__default.createElement(GroupChannelListProvider, __assign({}, props),
        React__default.createElement(GroupChannelListUI, __assign({}, props))));
};

export { GroupChannelList, GroupChannelList as default };
//# sourceMappingURL=GroupChannelList.js.map
